// Public surface for the offerings module (primary market).
//
// Offerings is a NAMESPACE parent — it has no chrome of its own. It groups
// three sibling sub-modules that together own the primary-market journey:
//   - browse/    — listings, filters, saved/bookmarked properties
//   - property/  — per-property detail (gallery, financials, documents)
//   - invest/    — buy flow + investment calculator
// External consumers go through @modules/offerings — never @modules/offerings/<sub>.

import { offeringsRoutes as browseRoutes } from './browse'
import { propertyRoutes } from './property'
import { investRoutes } from './invest'

export const offeringsRoutes = [...browseRoutes, ...propertyRoutes, ...investRoutes]

// browse — PROPERTY_STATUS enum drives gating in dashboard, property detail
// and the invest flow. Re-exported so consumers don't have to know which
// sibling owns the constant.
export {
  PROPERTY_STATUS,
  PROPERTY_STATUSES,
  type PropertyStatus,
  PROPERTY_IMAGE_PLACEHOLDER,
  useFeaturedPropertiesQuery,
} from './browse'
export type { PropertyListItem } from './browse'

// property — usePropertyDetail builds the per-property detail view-model and
// is consumed cross-module by portfolio's investment-detail container.
// PropertyDetailGallery is reused by portfolio's investment-detail surface.
// Promote to ui-kit/molecules if a third consumer appears.
export { usePropertyDetail, PropertyDetailGallery } from './property'
